import enUSMessages from './i18n/locales/en-US.json';
import thMessages from './i18n/locales/th.json';

const messagesByLocale = {
  'en-US': enUSMessages,
  th: thMessages,
  'th-TH': thMessages,
} as const;

export type SupportedLocale = keyof typeof messagesByLocale;

export const getInitialLocale = (): SupportedLocale => {
  if (typeof window === 'undefined') {
    return 'en-US';
  }

  const sessionLocale = window.sessionStorage.getItem(
    'locale',
  ) as SupportedLocale | null;
  if (sessionLocale && sessionLocale in messagesByLocale) {
    return sessionLocale;
  }

  const browserLocale = window.navigator.language as SupportedLocale;
  if (browserLocale in messagesByLocale) {
    return browserLocale;
  }

  return 'en-US';
};

export const getMessagesForLocale = (locale: string) =>
  messagesByLocale[locale as SupportedLocale] ?? messagesByLocale['en-US'];
